import _ from 'lodash';
import {combineReducers} from 'redux';

import {AppAction} from '../../appActions';
import {CommentsActionsEnum} from '../../data/comments/commentsActions';
import {CommentComposerActionsEnum} from './commentComposerActions';

/*
 * Constants.
 */

// Remember this many most recently expanded comments.
const maxExpandedCommentUidsSize = 10;

/*
 * Reducer.
 */

export const commentComposerReducer = combineReducers({
  expandedCommentUids: expandedCommentUidsReducer,
});

function expandedCommentUidsReducer(
  state: ReadonlyArray<string> = [],
  action: AppAction,
): ReadonlyArray<string> {
  switch (action.type) {
    case CommentComposerActionsEnum.EXPAND_COMMENT_COMPOSER: {
      const {commentUid} = action.payload;

      // Treat this as an FIFO cache and move the comment to the front.
      return _(state)
        .filter((uid) => uid !== commentUid)
        .slice(0, maxExpandedCommentUidsSize - 1)
        .unshift(commentUid)
        .value();
    }

    case CommentComposerActionsEnum.COLLAPSE_COMMENT_COMPOSER:
    case CommentsActionsEnum.COMMENT_DELETED:
      return state.filter((uid) => uid !== action.payload.commentUid);

    default:
      return state;
  }
}
